import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {NotificationPreferences} from '../../model/notification-preferences';
import {NotificationType} from '../../enum/notifications/notification-type';
import {Roles} from '../../enum/roles';

@Injectable({
  providedIn: 'root'
})
export class NotificationPreferencesService {

  constructor(private readonly http: HttpClient) {}

  // resolves notification categorization
  public isNotificationTriggerBelongingToNotificationType(notificationType: string, notificationTrigger: string): boolean {
    if (notificationType === NotificationType.PROPOSAL && notificationTrigger.startsWith("PROPOSAL_") &&
      notificationTrigger.toString() !== 'PROPOSAL_DEADLINE_DONE_RECEIVER' &&
      notificationTrigger.toString() !== 'PROPOSAL_DEADLINE_RECEIVER')
      return true;
    else if (notificationType === NotificationType.OFFER && notificationTrigger.startsWith("OFFER_"))
      return true;
    else if (notificationType === NotificationType.MEMBER_AREA && notificationTrigger.startsWith("MEMBERSHIP_"))
      return true;
    else if (notificationType === NotificationType.OFFER &&
      (notificationTrigger === 'PROPOSAL_DEADLINE_DONE_RECEIVER' || notificationTrigger === 'PROPOSAL_DEADLINE_RECEIVER'))
      return true;
    else
      return false;
  }

  // resolves if user has right to that notification
  public isUserAllowedToViewNotificationTrigger(notificationTrigger: string, userType: string, isRepresentative: boolean): boolean {
    const notificationRoles = new Map([
      ["PROPOSAL_CREATED", [Roles.ROLE_INSURER, Roles.ROLE_UNDERWRITER]],
      ["PROPOSAL_CREATED_RECEIVER", [Roles.ROLE_BROKER, Roles.ROLE_INSURER, Roles.ROLE_UNDERWRITER]],
      ["PROPOSAL_PRIVATE", [Roles.ROLE_BROKER, Roles.ROLE_INSURER, Roles.ROLE_UNDERWRITER]],
      ["PROPOSAL_PRIVATE_RECEIVER", [Roles.ROLE_INSURER, Roles.ROLE_UNDERWRITER]],
      ["PROPOSAL_REJECTED", [Roles.ROLE_BROKER, Roles.ROLE_INSURER, Roles.ROLE_UNDERWRITER]],
      ["PROPOSAL_REJECTED_RECEIVER", [Roles.ROLE_INSURER, Roles.ROLE_UNDERWRITER]],
      ["PROPOSAL_DEADLINE", [Roles.ROLE_BROKER, Roles.ROLE_INSURER, Roles.ROLE_UNDERWRITER]],
      ["PROPOSAL_DEADLINE_DONE", [Roles.ROLE_BROKER, Roles.ROLE_INSURER, Roles.ROLE_UNDERWRITER]],
      ["PROPOSAL_DEADLINE_DONE_RECEIVER", [Roles.ROLE_INSURER, Roles.ROLE_UNDERWRITER]],
      ["PROPOSAL_DEADLINE_RECEIVER", [Roles.ROLE_INSURER, Roles.ROLE_UNDERWRITER]],
      ["OFFER_CREATED", [Roles.ROLE_BROKER, Roles.ROLE_INSURER, Roles.ROLE_UNDERWRITER]],
      ["OFFER_ACCEPTED", [Roles.ROLE_INSURER, Roles.ROLE_UNDERWRITER]],
      ["OFFER_RETRACTED", [Roles.ROLE_BROKER, Roles.ROLE_INSURER, Roles.ROLE_UNDERWRITER]],
      ["MEMBERSHIP_APPLICATION", [Roles.ROLE_REPRESENTATIVE]]
    ]);

    const allowedRoles = notificationRoles.get(notificationTrigger);
    if (!allowedRoles) return false; //notificationTrigger not correct

    const userRoles = new Set<string>();

    if (userType) userRoles.add(userType);
    if (isRepresentative) userRoles.add(Roles.ROLE_REPRESENTATIVE);

    return allowedRoles.some(role => userRoles.has(role));
  }

  public getById(id: string): Observable<NotificationPreferences> {
    return this.http.get<NotificationPreferences>(environment.backend + '/v1/notification-preferences/' + id).pipe();
  }

  public findAllByUserId(userId: string): Observable<NotificationPreferences[]> {
    return this.http.get<NotificationPreferences[]>(environment.backend + '/v1/notification-preferences/user-id/' + userId).pipe();
  }

  public deleteById(id: string): Observable<void> {
    return this.http.delete<void>(environment.backend + '/v1/notification-preferences/delete/' + id).pipe();
  }

  public updateById(id: string, notificationPreferences: NotificationPreferences): Observable<void> {
    return this.http.put<void>(environment.backend + '/v1/notification-preferences/update/' + id, notificationPreferences).pipe();
  }

}
